// removed by extract-text-webpack-plugin
module.exports = {"field":"styles__field__1PmBD","addCNIWrapper":"styles__addCNIWrapper__2Vcj1","aspectRatioWrapper":"styles__aspectRatioWrapper__TZLuI","changeCNIField":"styles__changeCNIField__2Keii","addCNI":"styles__addCNI__3P7gd","addCNIInput":"styles__addCNIInput__1hsLM","choosePhotoText":"styles__choosePhotoText__3Ho_v","imageTypes":"styles__imageTypes__1OZeq","cautionMessage":"styles__cautionMessage__3vr7F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadFileField/styles.css
// module id = 2180
// module chunks = 0